import { FormControl, InputLabel, ListSubheader, MenuItem, Select } from '@mui/material'
import groupBy from 'lodash/groupBy'
import { useEffect, useState } from 'react'
import { LinearProgress, useGetList, useTranslate } from 'react-admin'
import { useFormContext } from 'react-hook-form'
import { makeStyles } from 'tss-react/mui'
import { Categories } from '~/graphql/generated'

const useStyles = makeStyles()((theme) => {
  console.log(theme)
  return {
    leftIcon: {
      marginRight: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    label: {
      background: theme.palette.background.default,
      padding: '0 2px',
    },
  }
})

const ToolbarAddBoatCategory = (props) => {
  const { classes } = useStyles()
  const translate = useTranslate()
  const { setValue, getValues } = useFormContext()
  const values = getValues()
  const [categoryId, setCategory] = useState('')

  const { data: categories, isLoading } = useGetList<Categories>('categories')

  const categoriesBySection = groupBy(categories, (category) => category.section?.slug)

  useEffect(() => {
    if (categoryId === '') return

    setValue('boat_section_category', [
      ...(values.boat_section_category ?? []),
      {
        category_id: categoryId,
      },
    ])
    setCategory('')
  }, [categoryId, setCategory, setValue])

  return isLoading ? (
    <LinearProgress />
  ) : (
    <>
      <FormControl variant='outlined' margin='dense' className={classes.formControl}>
        <InputLabel className={classes.label} id='category-label'>
          {translate('resources.categories.title')}
        </InputLabel>
        <Select
          labelId='category-label'
          onChange={(e) => setCategory(e.target.value)}
          value={categoryId}
        >
          {Object.keys(categoriesBySection).map((sectionSlug) => (
            <>
              <ListSubheader>{sectionSlug}</ListSubheader>
              {Object.values(categoriesBySection[sectionSlug]).map((category) => (
                <MenuItem key={category.id} value={category.id}>
                  {category.name}
                </MenuItem>
              ))}
            </>
          ))}
        </Select>
      </FormControl>
    </>
  )
}

export default ToolbarAddBoatCategory
